import React from 'react';
import ProjectSettingsModal from './ProjectSettingsModal';
import AccountSettingsModal from './AccountSettingsModal';
import ProfileModal from './ProfileModal';

const SettingsModals: React.FC = () => {
  return (
    <>
      <ProjectSettingsModal />
      <AccountSettingsModal />
      <ProfileModal />
    </>
  );
};

export default SettingsModals;
